// extracted by mini-css-extract-plugin
module.exports = {"accountMenuIcon":"styles_accountMenuIcon__LgPvK"};